import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { ComponentVisibilityService } from 'src/app/services/commonService/component-visibility.service';
import { Subject, combineLatest, takeUntil } from 'rxjs';
import { ContentService } from '../../services/content.service';
import { LocalSessionStorage } from 'src/app/models/interface/FlightSearch/CommanModel.interface';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { NgIf, NgFor } from '@angular/common';
import { WaitingComponent } from '../../../../shared/components/waiting/waiting.component';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


interface Department {
  Dept_Id: number;
  Dept_Name: string;
}

interface EmployeeGradeCategory {
  Category_ID: number;
  Category_Name: string;
}
interface Designation {
  Desig_Id: number;
  Desig_Name: string;
}
interface OfficeLocation {
  Branch_Id: number;
  Branch_Name: string;
}
// interface BusinessUnit {
//   BusinessUnit_Code: number;
//   BusinessUnit_Name: string;
// }
// interface Division {
//   BusinessTypeID: number;
//   BusinessType: string;
// }
interface Costcenter {
  CostCenter_Code: number;
  CostCenter_Name: string;
}
interface Porject {
  Project_Code: number;
  Project_Name: string;
}

@Component({
    selector: 'app-employee-details-form',
    templateUrl: './employee-details-form.component.html',
    styleUrls: ['./employee-details-form.component.scss'],
    imports: [NgIf, WaitingComponent, ReactiveFormsModule, MatIcon, MatFormField, MatLabel, MatSuffix, MatSelect, NgFor, MatOption, MatError, MatButton, MatProgressSpinner]
})
export class EmployeeDetailsFormComponent implements OnInit, OnDestroy {
  EmployeeForm: FormGroup;
  editemployee: boolean = false;
  userId: string = '';
  guid: string = '';
  userData: any[] = [];
  departments: Department[] = [];
  employeeGradeCategories: EmployeeGradeCategory[] = [];
  designation: Designation[] = [];
  officeLocations: OfficeLocation[] = [];
  // businessUnit: BusinessUnit[] = [];
  // division: Division[] = [];
  costcenter: Costcenter[] = [];
  porject: Porject[] = [];

  DeptId: string = '';
  DesigId: string = '';
  DivisionID: string = '';
  BusinessUnitId: string = '';
  OfficeLocationId: string = '';
  CostCenterId: string = '';
  ProjectId: string = '';
  SABranchID: string = '';
  loginName: string = '';
  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }
  loginType: any
  hasEmployeeData: boolean = false;
  noDataPersonalInfo!: boolean
  content:any;
  companySettingDetails: any = {};
  // isProfileViewRestricted: boolean = false;
  private destroy$ = new Subject<void>();
  constructor(
    private fb: FormBuilder,
    public visibilityService: ComponentVisibilityService,
    private _CamApiService: CamService,
    public _ApiService: ApiService, private cdr: ChangeDetectorRef,
    private _ToastrApiService: ToastrApiService,
    private readonly dictionaryContentService:DisctionaryContent,
    private _CommonService: CommonService,
    private contentService:ContentService,
    private readonly crypto: CryptoService,
    private readonly travelerManagement:TravelerManagement
  ) {
    this.EmployeeForm = this.fb.group({
      Department: [''],
      EmployeeGradeCategory: [''],
      Designation: [''],
      // Division: [''],
      // BusinessUnit: [''],
      OfficeLocation: [''],
      CostCenter: [''],
      ProjectName: ['']
    });
  }
  ngOnInit(): void {

    this.Loader.isSpinner = true; // ✅ loader start
    setTimeout(() => {
      this.Loader.isSpinner = false; // ✅ 2 sec baad band
    }, 2000);

    combineLatest({ content:this.contentService.content$,dictionary:this.dictionaryContentService.content$
    }).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
     this.content = {
        ...res.content,
        dictionary:res.dictionary
      }
    });
    this.loginType = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string
    this.userId = sessionStorage.getItem('userId') || '';
    this.guid = sessionStorage.getItem('guid') || '';
    const stored = localStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS) ?? sessionStorage.getItem(LocalSessionStorage.COMPANY_SETTINGS);
    this.companySettingDetails = stored && stored !== 'undefined' ? JSON.parse(stored) : {};
    // const travelerGUID = localStorage.getItem('travelerGUID')?.toLowerCase();
    // const userGuid = localStorage.getItem('userGuid')?.toLowerCase();
    // this.isProfileViewRestricted = this.companySettingDetails?.restrictAmendmentInTravelerProfile && (travelerGUID !== userGuid);
    // if (this.isProfileViewRestricted) {
    //   this.EmployeeForm.disable();
    // }

    this.loadUserExecutiveData();
    this.noDataPersonalInfo = this._CommonService.getData('camSidebar')

  }
  private loadUserExecutiveData() {
    this.editemployee = true;
    // this.Loader.isEditableClicked = true;
    this._CamApiService.GetUserExecutive(this.userId, this.guid).then((response: any) => {
      if (response?.status === 'Success') {
        this.userData = response.data.SubagentUser;
        this.departments = response.data.department;
        this.employeeGradeCategories = response.data.UserGradeCategory;
        this.designation = response.data.Designation;
        this.officeLocations = response.data.Table_12;
        // this.businessUnit = response.data.BusinessUnit;
        // this.division = response.data.division;
        this.costcenter = response.data.CostCenter;
        this.porject = response.data.Porject;
        this.prefillForm(this.userData);
        this.prefillDetails(this.userData);
      }
    }).catch((error: any) => { console.error('Error fetching Pax Titles:', error); });
  }
  Editemployee() {
    this.editemployee = true;
    this.Loader.isEditableClicked = false;
    this.travelerManagement.traveler_detail_click('Edit');
  }
  Cancel() {
    this.travelerManagement.traveler_detail_click('Cancel');
    this.editemployee = false;
    if (this.hasEmployeeData) {
      this.Loader.isEditableClicked = true;
    } else {
      this.EmployeeForm.reset();
      //       Object.keys(this.EmployeeForm.controls).forEach(key => {
      //   this.EmployeeForm.get(key)?.markAsUntouched();
      //   this.EmployeeForm.get(key)?.markAsPristine();
      // });
      this.Loader.isEditableClicked = false;
    }
  }
  prefillForm(userData: any[]): void {
    if (userData && userData.length > 0) {
      const user = userData[0];
      const department = this.departments.find(dept => dept.Dept_Id === user.Dept_Id);
      const gradeCategory = this.employeeGradeCategories.find(category => category.Category_ID === user.Employee_GradeCategory);
      const designation = this.designation.find(desi => desi.Desig_Id === user.Desig_Id);
      // const division = this.division.find(divi => divi.BusinessTypeID === user.DivisionID);
      const officeLocation = this.officeLocations.find(office => office.Branch_Id === user.Branch_Id);
      // const businessunit = this.businessUnit.find(busin => busin.BusinessUnit_Code === user.Business_Unit_Id);
      const costcenter = this.costcenter.find(cost => cost.CostCenter_Code === user.Cost_Center_Id);
      const projectname = this.porject.find(proj => proj.Project_Code === user.Project_Id);
      this.EmployeeForm.patchValue({
        Department: department ? department.Dept_Id : null,
        EmployeeGradeCategory: gradeCategory ? gradeCategory.Category_ID : null,
        Designation: designation ? designation.Desig_Id : null,
        // Division: division ? division.BusinessTypeID : null,
        // BusinessUnit: businessunit ? businessunit.BusinessUnit_Code : null,
        OfficeLocation: officeLocation ? officeLocation.Branch_Id : null,
        CostCenter: costcenter ? costcenter.CostCenter_Code : null,
        ProjectName: projectname ? projectname.Project_Code : null,
      });

      this.hasEmployeeData = this._CommonService.hasAnyValue(this.EmployeeForm.value)// value is in form or not
      if (this.hasEmployeeData) {
        this.Loader.isEditableClicked = true;
      } else {
        this.Loader.isEditableClicked = false;
      }

      this.cdr.detectChanges();
    } else {
      console.error('No user data provided to prefill the form.');
    }
  }

  prefillDetails(userData: any[]): void {
    if (userData && userData.length > 0) {
      const user = userData[0];
      this.DeptId = user.Dept_Id || '';
      this.DesigId = user.Desig_Name || '';
      // this.DivisionID = user.DivisionID || '';
      // this.BusinessUnitId = user.Business_Unit_Id || '';
      this.OfficeLocationId = user.Branch_Id || '';
      this.CostCenterId = user.Cost_Center_Id || '';
      this.ProjectId = user.Project_Id || '';
      this.SABranchID = user.SA_Branch_ID || '';
      this.loginName = user.login_Name || '';

      this.cdr.detectChanges();
    } else {
      console.error('No user data provided to prefill the form.');
    }
  }
  onSave() {
    if (this.EmployeeForm.valid) {
      this.travelerManagement.traveler_detail_click('Save');
      const payload = {
        departmentId: Number(this.EmployeeForm.get('Department')?.value) || 0,
        employeeGradeCategory: Number(this.EmployeeForm.get('EmployeeGradeCategory')?.value) || 0,
        designationId: Number(this.EmployeeForm.get('Designation')?.value) || 0,
        // divisionID: Number(this.EmployeeForm.get('Division')?.value) || 0,
        // businessUnitId: Number(this.EmployeeForm.get('BusinessUnit')?.value) || 0,
        // branchId: Number(this.EmployeeForm.get('OfficeLocation')?.value) || 0,
        costCenterId: Number(this.EmployeeForm.get('CostCenter')?.value) || 0,
        projectId: Number(this.EmployeeForm.get('ProjectName')?.value) || 0,
        queryNo: 15,
        guid: this.guid,
        login_name: this.loginName,
        branchId: Number(this.EmployeeForm.get('OfficeLocation')?.value) || 0,
      };
      this.Loader.isEditableClicked = true;
      this._CamApiService.UpdateEmployeeDetails(payload, this.userId).then(response => {
        this._ToastrApiService.show('success', "Employment Details updated successfully.");
        this.Loader.isEditableClicked = true;
        this.loadUserExecutiveData();
      })
        .catch(error => {
          console.error('Error:', error);
          this.Loader.isEditableClicked = false;
        });
    } else {
      console.warn('Form is invalid');
      this.EmployeeForm.markAllAsTouched();
    }
  }

ngOnDestroy(){
  this.destroy$.next();
  this.destroy$.complete();
}

}


